import styled from 'styled-components';

export const StyledCpscCoreFormDiv = styled.div`
  .radio-group-horizontal .ant-radio-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  }

  .radio-group-horizontal .ant-radio-wrapper {
    display: flex;
    align-items: center;
    margin-right: 20px;
    white-space: nowrap;
  }
`;
